import { getUserId } from 'api/api';
import { createRoot } from 'react-dom/client';
import { AppWithProviders } from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
// redirect www to non-www, keep everything else the same
const url = new URL(window.location.href);
const interval = setInterval(() => {
  const overlay = document.querySelector('#react-refresh-overlay');
  if (overlay) {
    overlay.remove();
    clearInterval(interval);
  }
}, 10);

if (url.hostname.startsWith('www.')) {
  window.location.href = url.href.replace(url.hostname, url.hostname.slice(4));
} else {
  getUserId().then(() => {
    const root = createRoot(document.getElementById('root')!);
    root.render(<AppWithProviders />);
  });

  if (module.hot) {
    module.hot.accept();
  }

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

if (module.hot) {
  module.hot.accept();
}
